import React from 'react'
import { Box, Grid, InputAdornment, InputLabel, MenuItem, TextField, Typography } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import DateIcon from 'asterX-UI/Icons/DateIcon'
import { GRAY_COLORS } from 'asterX-UI'
import { SelectPlaceholder } from 'asterX-UI/Inputs'
import { useStyles } from '../../../pages/ContractPage/components/AddEvents/add-events.styles'
import FileUploadCard from './FileUploadCardInline'

const SuspensionSection = ({
  suspension,
  monthsPreview,
  onPathChange,
  onDateChange,
  onFileChange,
  onDeleteFile,
  IconComponent,
  reasons,
  applicationPath,
  workCertPath,
  incomeProofPath,
  monthPillStyle,
  errors = {}
}) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel}>
          Срок отсрочки и дата начала *
        </InputLabel>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <SelectPlaceholder
              IconComponent={IconComponent}
              name="suspension.termMonths"
              value={suspension.termMonths}
              onChange={onPathChange}
              fullWidth
              placeholder="Срок отсрочки"
              error={Boolean(errors['suspension.termMonths'])}
            >
              <MenuItem value={''}>Не выбрано</MenuItem>
              {[3, 4, 5, 6].map(m => (
                <MenuItem key={m} value={m}>{`${m} мес.`}</MenuItem>
              ))}
            </SelectPlaceholder>
          </Grid>

          <Grid item xs={12} md={6}>
            <DatePicker
              placeholder="Дата начала"
              format="dd.MM.yyyy"
              disablePast
              value={suspension.startDate}
              onChange={date => onDateChange('suspension.startDate', date)}
              fullWidth
              TextFieldComponent={props => (
                <TextField
                  {...props}
                  error={Boolean(errors['suspension.startDate'])}
                  helperText={errors['suspension.startDate'] || ''}
                />
              )}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start" style={{cursor: 'pointer'}}>
                    <DateIcon style={{ color: GRAY_COLORS[500] }} />
                  </InputAdornment>
                )
              }}
            />

          </Grid>
        </Grid>
      </Grid>

      {monthsPreview?.length > 0 && (
        <Grid item xs={12} className={classes.item}>
          <Typography variant="body2" style={{ marginBottom: 8 }}>
            Месяцы отсрочки (для согласования и передачи в BS):
          </Typography>
          <Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
            {monthsPreview.map(m => (
              <Box key={m} px={1} py={0.5} style={monthPillStyle}>
                <Typography variant="body2">{m}</Typography>
              </Box>
            ))}
          </Box>
        </Grid>
      )}

      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel}>
          Причина отсрочки *
        </InputLabel>
        <SelectPlaceholder
          IconComponent={IconComponent}
          name="suspension.reason"
          value={suspension.reason}
          onChange={onPathChange}
          fullWidth
          placeholder="Не выбрано"
          error={Boolean(errors['suspension.reason'])}
        >
          <MenuItem value={''}>Не выбрано</MenuItem>
          {reasons.map(r => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </SelectPlaceholder>
      </Grid>

      {suspension.reason === 'Другие' && (
        <Grid item xs={12} className={classes.item}>
          <TextField
            label="Другая причина"
            fullWidth
            name="suspension.otherReason"
            value={suspension.otherReason}
            onChange={onPathChange}
            multiline
            minRows={3}
            className={errors['suspension.otherReason'] ? classes.errorField : undefined}
          />
        </Grid>
      )}

      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel}>
          Заявление на отсрочку (с подписью клиента) *
        </InputLabel>
        <FileUploadCard
          label="Нажмите, чтобы загрузить"
          file={suspension.files?.application || null}
          path={applicationPath}
          onFileChange={onFileChange}
          onDelete={onDeleteFile}
          error={Boolean(errors[applicationPath])}
        />
      </Grid>

      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel}>
          Справка с места работы *
        </InputLabel>
        <FileUploadCard
          label="Нажмите, чтобы загрузить"
          file={suspension.files?.workCertificate || null}
          path={workCertPath}
          onFileChange={onFileChange}
          onDelete={onDeleteFile}
          error={Boolean(errors[workCertPath])}
        />
      </Grid>

      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel}>
          Подтверждающие документы о потере дохода *
        </InputLabel>
        <FileUploadCard
          label="Нажмите, чтобы загрузить"
          file={suspension.files?.incomeProof || null}

          path={incomeProofPath}
          onFileChange={onFileChange}
          onDelete={onDeleteFile}
          error={Boolean(errors[incomeProofPath])}
        />
      </Grid>
    </>
  )
}

export default SuspensionSection
